function getMaxDuration(el) {
	let max = 0
	const style = getComputedStyle(el)
	const durations = style.transitionDuration.split(', ').map(parseFloat)
	const delays = style.transitionDelay.split(', ').map(parseFloat)
	for (let i in durations) {
		const total = durations[i] + delays[i]
		if (total > max) max = total
	}
	return max
}

export function afterTransition(el, onTransitionEnd = () => {}) {
	if (el.__handler) 
		el.removeEventListener('transitionend', el.__handler)

	const handler = el.__handler = event => {
		if (el !== event.target) return
		event.stopPropagation()
		el.removeEventListener('transitionend', handler)
		onTransitionEnd(el)
	}

	if (getMaxDuration(el)) {
		el.addEventListener('transitionend', handler)
	} else {
		// run onTransitionEnd after in the next frame (after possible animation triggers)
		window.requestAnimationFrame(() => onTransitionEnd(el))
	}
}

export function slideDown(el, callback = () => {}) {
	const style = getComputedStyle(el)
	const from = (style.display === 'none') ? '0px' : style.height

	// measure full height
	el.style.height = 'auto'
	el.style.display = 'block'
	el.style.overflow = 'hidden'

	el.getBoundingClientRect()
	const to = `${el.clientHeight}px`

	el.style.height = from
	afterTransition(el, el => {
		el.style.height = ''
		el.style.display = ''
		el.style.overflow = ''
		el.style.height = ''
		callback(el, true)
	})
	el.style.height = to
}

export function slideUp(el, callback = () => {}) {
	el.style.height = `${el.clientHeight}px`
	el.style.overflow = 'hidden'
	afterTransition(el, el => {
		el.style.display = 'none'
		el.style.height = ''
		el.style.overflow = ''
		callback(el, true)
	})
	el.style.height = '0px'
}